import { ConnectionHandler } from 'relay-runtime';
export default function rangeAddUpdater(store, {
  parentId,
  connectionKey,
  connectionFilters,
  rootFieldName,
  edgeName,
  rangeBehavior = 'prepend'
}) {
  const connection = ConnectionHandler.getConnection(store.get(parentId), connectionKey, connectionFilters);

  if (!connection) {
    return;
  }

  const newEdge = store.getRootField(rootFieldName).getLinkedRecord(edgeName); // Do not add duplicates to connection.

  const newDataId = newEdge.getLinkedRecord('node').getDataID();

  if (connection.getLinkedRecords('edges').some(edge => edge.getLinkedRecord('node').getDataID() === newDataId)) {
    return;
  } // Copy the edge to avoid issues with facebook/relay#2349.


  const copiedEdge = ConnectionHandler.buildConnectionEdge(store, connection, newEdge);

  if (rangeBehavior === 'prepend') {
    ConnectionHandler.insertEdgeBefore(connection, copiedEdge);
  } else {
    ConnectionHandler.insertEdgeAfter(connection, copiedEdge);
  }
}